export const ParseErrorHandler = {
    methods: {
        handleError(error) {
            switch (error.code) {
                case this.$parse.Error.INVALID_SESSION_TOKEN:
                    this.$parse.User.logOut();
                    break;
                case this.$parse.Error.OBJECT_NOT_FOUND:
                    this.$notify({
                        title: 'Login fehlgeschlagen',
                        message: this.$createElement(
                            'i',
                            { style: 'color: red' },
                            'Die eingebenen Daten wurden nicht gefunden.'
                        ),
                    });
                    break;
                default:
                    this.$notify({
                        title: 'Error',
                        message: this.$createElement('i', { style: 'color: red' }, error.message),
                    });
                    break;
            }
        }
    }
}
